import { motion } from "framer-motion";
import { Inbox, ListChecks, Users } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const steps = [
  { icon: Inbox, title: "Drop it into Otti.", text: "Add an email, photo, document or voice note.", id: "drop-it-in" },
  { icon: ListChecks, title: "See who’s doing what.", text: "Turn scattered details into tasks and events with clear responsibilities.", id: "who-does-what" },
  { icon: Users, title: "Share the follow-through.", text: "Let Otti send relevant reminders, so they don’t all have to come from you.", id: "follow-through" },
];

const Step = ({ s, i }) => (
  <Reveal delay={i * 0.1} className="h-full">
    <motion.article
      data-testid={`step-card-${s.id}`}
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 260, damping: 22 }}
      className={`flex h-full flex-col rounded-[2rem] border p-7 sm:p-8 ${i === 2 ? "border-[#1C2B4A] bg-[#1C2B4A] text-[#FAF7F2]" : "border-[#E4DDD3] bg-[#FAF4ED] text-[#16203A]"}`}
    >
      <div className="flex items-center justify-between">
        <span className={`grid h-11 w-11 place-items-center rounded-full ${i === 2 ? "bg-[#FAF7F2]/10 text-[#E9DCC3]" : "bg-[#E3E8F1] text-[#1C2B4A]"}`}>
          <s.icon className="h-5 w-5" />
        </span>
        <span className={`font-display text-4xl font-light ${i === 2 ? "text-[#C9D2E3]" : "text-[#3D5585]"}`}>0{i + 1}</span>
      </div>
      <h3 className="font-display mt-6 text-2xl font-normal tracking-tight sm:text-[1.7rem]">{s.title}</h3>
      <p className={`mt-3 text-base leading-relaxed ${i === 2 ? "text-[#E3E8F1]" : "text-[#464E62]"}`}>{s.text}</p>
    </motion.article>
  </Reveal>
);

export const Steps = () => (
  <section id="how-it-helps" className="px-5 py-20 sm:px-8 sm:py-24" data-testid="steps-section">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <h2 data-testid="steps-heading" className="font-display text-3xl font-normal leading-[1.15] tracking-tight text-[#16203A] sm:text-4xl lg:text-5xl">
          How Otti <span className="italic text-[#3D5585]">will help</span>
        </h2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
        {steps.map((s, i) => <Step key={s.id} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
